import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
    Inbox,
    Send,
    FileText,
    Trash2,
    PenSquare,
    LogOut,
    Mail
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function Sidebar() {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const navItems = [
        { to: '/inbox', icon: Inbox, label: 'Inbox' },
        { to: '/sent', icon: Send, label: 'Sent' },
        { to: '/drafts', icon: FileText, label: 'Drafts' },
        { to: '/trash', icon: Trash2, label: 'Trash' },
    ];

    return (
        <div className="bg-[#1e293b] text-slate-300 w-64 flex flex-col h-full shadow-xl z-20">
            {/* Brand Area */}
            <div className="p-6 flex items-center space-x-3 text-white">
                <div className="bg-blue-600 p-2 rounded-lg">
                    <Mail className="h-6 w-6" />
                </div>
                <span className="text-xl font-bold tracking-tight">MailClient</span>
            </div>

            {/* Compose Button */}
            <div className="px-4 mb-6">
                <button
                    onClick={() => navigate('/compose')}
                    className="w-full bg-blue-600 hover:bg-blue-500 text-white px-4 py-3 rounded-xl flex items-center justify-center transition-all shadow-lg shadow-blue-900/20 font-medium"
                >
                    <PenSquare className="h-5 w-5 mr-2" />
                    Compose
                </button>
            </div>

            {/* Navigation */}
            <nav className="flex-1 px-3 space-y-1">
                {navItems.map(({ to, icon: Icon, label }) => (
                    <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) =>
                            `flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all ${isActive
                                ? 'bg-slate-700/50 text-white shadow-sm'
                                : 'hover:bg-slate-800 hover:text-white'
                            }`
                        }
                    >
                        <Icon className="mr-3 h-5 w-5" />
                        {label}
                    </NavLink>
                ))}
            </nav>

            {/* Footer */}
            <div className="p-4 border-t border-slate-700/50 bg-[#1e293b]">
                <div className="text-xs text-slate-500 mb-4 px-2">
                    <p className="flex items-center gap-1">
                        <span className="w-2 h-2 rounded-full bg-green-500"></span> POP3 Connected
                    </p>
                </div>
                <button
                    onClick={handleLogout}
                    className="w-full flex items-center px-4 py-2 text-sm font-medium text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
                >
                    <LogOut className="mr-3 h-5 w-5" />
                    Sign Out
                </button>
            </div>
        </div>
    );
}